
import { Button } from "@/components/ui/button";

interface ServiceCTAProps {
  text: string;
  buttonText: string;
}

export const ServiceCTA = ({ text, buttonText }: ServiceCTAProps) => {
  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="py-16 bg-primary/10">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-3xl mx-auto space-y-6">
          <h2 className="text-3xl font-bold">{text}</h2>
          <div>
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-primary hover:bg-primary/90"
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export type { ServiceCTAProps };
